import { render, staticRenderFns } from "./PipiPupuFileS3.vue?vue&type=template&id=c3b049fa"
import script from "./PipiPupuFileS3.vue?vue&type=script&lang=js"
export * from "./PipiPupuFileS3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports